'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Lamp = function (_React$PureComponent) {
  _inherits(Lamp, _React$PureComponent);

  function Lamp() {
    _classCallCheck(this, Lamp);

    return _possibleConstructorReturn(this, (Lamp.__proto__ || Object.getPrototypeOf(Lamp)).apply(this, arguments));
  }

  _createClass(Lamp, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: this.props.size,
          height: this.props.size,
          viewBox: '0 0 128 128'
        },
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement('path', {
            fill: '#231F20',
            d: 'M78.019 86.323v8.36h.142c.3-.024.6-.024.9 0 2.747.343 4.842 2.237 4.842 4.534a4.026 4.026 0 0 1-1.314 2.925l-.367.332a6.512 6.512 0 0 1-4.061 1.35c.301 0 .602.023.9.07 2.747.332 4.842 2.226 4.842 4.535a4.18 4.18 0 0 1-1.693 3.328 6.512 6.512 0 0 1-4.061 1.35h-5.755a8.23 8.23 0 0 1-15.996 0h-5.79c-3.162 0-5.72-2.073-5.72-4.607a4.144 4.144 0 0 1 1.682-3.256 6.441 6.441 0 0 1 4.038-1.35c-3.162 0-5.72-2.06-5.72-4.606a4.109 4.109 0 0 1 1.682-3.244 6.37 6.37 0 0 1 4.038-1.35h.154v-8.371c-14.95-6.458-23.307-22.527-20.01-38.475 3.297-15.947 17.342-27.385 33.626-27.385 16.285 0 30.33 11.438 33.627 27.385 3.297 15.948-5.06 32.017-20.01 38.475h.024z',
            opacity: '.15'
          }),
          _react2.default.createElement('path', {
            fill: this.props.color,
            d: 'M98.669 50.186a34.338 34.338 0 0 1-20.65 31.389v7.294H50.785v-7.294c-15.722-6.809-24-24.184-19.38-40.683 4.619-16.5 20.715-27.051 37.687-24.706 16.973 2.345 29.604 16.866 29.577 34z'
          }),
          _react2.default.createElement('path', {
            fill: '#767C7C',
            d: 'M83.903 103.74a4.18 4.18 0 0 1-1.693 3.28 6.512 6.512 0 0 1-4.061 1.35h-5.755a8.23 8.23 0 0 1-15.996 0h-5.79c-3.162 0-5.72-2.072-5.72-4.606a4.144 4.144 0 0 1 1.682-3.256 6.441 6.441 0 0 1 4.038-1.35c-3.162 0-5.72-2.06-5.72-4.606a4.109 4.109 0 0 1 1.682-3.244 6.37 6.37 0 0 1 4.038-1.35H78.16c.3-.023.6-.023.9 0 2.747.343 4.842 2.238 4.842 4.535a4.026 4.026 0 0 1-1.314 2.925l-.379.367a6.512 6.512 0 0 1-4.061 1.35c.301 0 .602.023.9.07 2.759.332 4.854 2.227 4.854 4.535z'
          }),
          _react2.default.createElement('path', {
            fill: this.props.color,
            opacity: '.7',
            d: 'M98.657 45.39A34.338 34.338 0 0 1 78.019 76.84V86.5H50.785v-9.662c-15.733-6.797-24.03-24.17-19.425-40.678 4.605-16.51 20.696-27.08 37.676-24.75 16.98 2.328 29.63 16.84 29.62 33.98z'
          }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            d: 'M69.932 60.25h2.072a2.048 2.048 0 1 0-2.06-2.048c.004.067.004.134 0 .201l-.012 1.847zm-11.083 3.233h-2.19a1.61 1.61 0 0 1-.356 0 5.269 5.269 0 1 1 5.778-5.293v2.06h4.642v-1.847-.107-.106a5.293 5.293 0 1 1 5.66 5.257H69.932V77.42a1.61 1.61 0 0 1-3.221 0V63.483h-4.63v13.936a1.61 1.61 0 0 1-3.22 0l-.012-13.936zm0-3.233v-1.847a1.622 1.622 0 0 1 0-.201 2.06 2.06 0 1 0-2.06 2.048h2.072-.012z',
            opacity: '.7'
          }),
          _react2.default.createElement('path', {
            fill: '#424849',
            d: 'M64.39 109.921a8.288 8.288 0 0 1-8.288-8.288c0-.983 16.47-.983 16.47 0a8.288 8.288 0 0 1-8.288 8.288'
          }),
          _react2.default.createElement('path', { fill: '#B7C1C4', d: 'M77.296 85.198h.178c.282 0 .563.024.84.071' }),
          _react2.default.createElement('path', {
            fill: '#B7C1C4',
            d: 'M79.049 85.257c2.759.332 4.843 2.238 4.843 4.535a4.18 4.18 0 0 1-1.682 3.256 6.512 6.512 0 0 1-4.061 1.35H50.608c-3.162 0-5.72-2.072-5.72-4.606a4.168 4.168 0 0 1 1.682-3.256 6.406 6.406 0 0 1 4.038-1.35H78.16c.301.002.602.026.9.071'
          }),
          _react2.default.createElement('path', {
            fill: '#000',
            fillRule: 'nonzero',
            d: 'M83.892 89.792a4.18 4.18 0 0 1-1.682 3.256 6.512 6.512 0 0 1-4.061 1.35H50.608c-3.162 0-5.72-2.072-5.72-4.606 0 0 .77.095 19.514 0 18.744-.094 19.49 0 19.49 0z',
            opacity: '.15'
          }),
          _react2.default.createElement('path', {
            fill: '#B7C1C4',
            d: 'M79.049 94.47c2.759.33 4.843 2.237 4.843 4.534a4.18 4.18 0 0 1-1.682 3.28 6.512 6.512 0 0 1-4.061 1.35H50.608c-3.162 0-5.72-2.072-5.72-4.606a4.168 4.168 0 0 1 1.682-3.256 6.406 6.406 0 0 1 4.038-1.35H78.16c.301.002.602.025.9.071'
          }),
          _react2.default.createElement('path', {
            fill: '#000',
            fillRule: 'nonzero',
            d: 'M83.892 99.004a4.18 4.18 0 0 1-1.682 3.28 6.512 6.512 0 0 1-4.061 1.35H50.608c-3.162 0-5.72-2.072-5.72-4.606 0 0 .77.095 19.514 0s19.49-.024 19.49-.024z',
            opacity: '.15'
          }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            fillRule: 'nonzero',
            d: 'M93.329 38.487a1.184 1.184 0 0 1-1.185-.888C89.776 28.21 79.5 18.465 70.216 16.76a1.203 1.203 0 0 1 .426-2.367C80.707 16.25 91.825 26.8 94.43 36.972a1.184 1.184 0 0 1-1.184 1.48l.083.035z',
            opacity: '.5'
          })
        )
      );
    }
  }]);

  return Lamp;
}(_react2.default.PureComponent);

Lamp.defaultProps = {
  size: 64,
  color: '#F1C40F'
};

Lamp.propTypes = {
  size: _propTypes2.default.number,
  color: _propTypes2.default.string
};

exports.default = Lamp;